import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import PageHeader from "../Components/Pageheader";
import "../assets/Css/cart.css";
import { carddetail } from "../Constant/Index";
import { Link } from "react-router-dom";

const wishlist = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="Wishlist" />
			<section className="ourproduct-slider my-card-main">
				<div className="container">
					<div className="row">
						<div className="col-lg-12 mx-auto">
							<div className="row">
								<div className="col-lg-12">
									<div className="table-wrapper">
										<div className="responsive-table">
											<table className="table">
												<thead>
													<tr>
														<th></th>
														<th>Product Image</th>
														<th>Product Name</th>
														<th>Stock Status</th>
														<th>Unit Price</th>
														<th>Action</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>
															<div className="cancle-axe">
																<a href="#">
																	<i class="fa-solid fa-xmark"></i>
																</a>
															</div>
														</td>
														<td>
															<img
																className="image-table-wrapper"
																src={carddetail}
																alt="Product"
															/>
														</td>
														<td>
															<h4 className="bags">Magnesium Bath Salt</h4>
														</td>
														<td>
															<span className="out-of-stock">Out Of Stock</span>
														</td>
														<td>$49.0</td>
														<td>
															<span className="add-notify">Notify Me</span>
														</td>
													</tr>
													<tr>
														<td>
															<div className="cancle-axe">
																<a href="#">
																	<i class="fa-solid fa-xmark"></i>
																</a>
															</div>
														</td>
														<td>
															<img
																className="image-table-wrapper"
																src={carddetail}
																alt="Product"
															/>
														</td>
														<td>
															<h4 className="bags">Magnesium Bath Salt</h4>
														</td>
														<td>
															<span className="add-notify">In Stock 15</span>
														</td>
														<td>$49.0</td>
														<td>
															<div className="text-center-wrap">
																<Link
																	to="/cart"
																	className="btn-all-wrapper add-to-card-bth"
																>
																	Add To Cart
																</Link>
															</div>
														</td>
													</tr>
													<tr>
														<td>
															<div className="cancle-axe">
																<a href="#">
																	<i class="fa-solid fa-xmark"></i>
																</a>
															</div>
														</td>
														<td>
															<img
																className="image-table-wrapper"
																src={carddetail}
																alt="Product"
															/>
														</td>
														<td>
															<h4 className="bags">Magnesium Bath Salt</h4>
														</td>
														<td>
															<span className="add-notify">In Stock 15</span>
														</td>
														<td>$49.0</td>
														<td>
															<div className="text-center-wrap">
																<Link
																	to="/cart"
																	className="btn-all-wrapper add-to-card-bth"
																>
																	Add To Cart
																</Link>
															</div>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default wishlist;
